exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.loader--1GJ1mFqP{background:linear-gradient(150deg,#5ed6eb,#228cc5 80%,#228cc5);width:100%;height:100%;position:absolute;display:flex;flex-direction:column;justify-content:center;align-items:center}.logo--fYU0kX5M{width:20rem}.logo--fYU0kX5M svg{background-color:transparent}.text--VUCso_CO{font-size:2rem}", ""]);

// exports
exports.locals = {
	"loader": "loader--1GJ1mFqP",
	"logo": "logo--fYU0kX5M",
	"text": "text--VUCso_CO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/loader.scss
// module id = 1011
// module chunks = 0